function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgButtonSettings = function SvgButtonSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    preserveAspectRatio: "none",
    viewBox: "0 0 34 34"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M23.4 17a5 5 0 1 1-10 0c0-2.78 1.79-5 4.56-5a5.17 5.17 0 0 1 5.49 5m10.05.46-2.74-6.4-4.62.94-2.74-3.68 1.82-4.57L18.83 1l-2.74 7.32-3.66.91-3.65-4.57-3.66 5.49 4.57 3.65-.91 3.66-8.23 1.82 4.57 8.23 6.4-3.66 2.74 2.74-1.83 5.49 5.48.91 1.83-6.4h3.66l2.74 4.57 4.57-4.57-4.57-4.32.91-3.53Z",
    "data-name": "Header Buttons",
    style: {
      fill: "#ffce41"
    }
  }));
};
export default SvgButtonSettings;